import { useState, useCallback } from "react";

const usePersistedPageSize = (key, defaultSize = 20) => {
  const [pageSize, setPageSize] = useState(() => {
    try {
      const stored = sessionStorage.getItem(`pageSize_${key}`);
      return stored ? Number(stored) : defaultSize;
    } catch {
      return defaultSize;
    }
  });

  const setPersistedPageSize = useCallback((size) => {
    const numSize = Number(size);
    setPageSize(numSize);
    sessionStorage.setItem(`pageSize_${key}`, String(numSize));
  }, [key]);

  return [pageSize, setPersistedPageSize];
};

export default usePersistedPageSize;
